import { render, staticRenderFns } from "./LocationOrders.vue?vue&type=template&id=1dd0aa48&"
import script from "./LocationOrders.vue?vue&type=script&lang=js&"
export * from "./LocationOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports